<template>
  <v-card class="white">
    <v-card-title primary-title>
      自定义查询
    </v-card-title>
    <v-form @submit.native.prevent>
      <v-container grid-list-xs>
        <v-layout column>
          <v-layout row v-for="(item, index) in conditions" :key="index" align-center>
            <!-- <v-flex xs2>
              <span class="caption">{{item.prop.text}}</span>
            </v-flex> -->
            <v-flex xs2>
              <v-select :items="symbols" v-model="item.symbol"></v-select>
            </v-flex>
            <v-flex xs8>
              <gh-input v-model="item.value" :prop="item.prop"></gh-input>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-container>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn ref="btnCancel" color="info" flat @click="cancel">取消</v-btn>
        <v-btn x-large ref="btnOk" color="success" @click="submit">确定</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<style scoped>

</style>

<script>
  import GhCustomFilter from "./ghCustomFilter.ts";
  export default GhCustomFilter;
</script>